import React from "react";
import { AcquireMode } from "../../singleton/createSingleton";
import { FaceTecInitParams } from "../init";
import useManageFaceTecInstance from "../useManageFaceTecInstance";
import { FaceTecInstanceContext } from "./state";

type Props = {
  children: React.ReactNode;
  initParams: FaceTecInitParams;
  mode: AcquireMode;
};

const FaceTecInstanceInit: React.FC<Props> = (props) => {
  const { children, initParams, mode } = props;

  const value = useManageFaceTecInstance(initParams, mode);

  return (
    <FaceTecInstanceContext.Provider value={value}>
      {children}
    </FaceTecInstanceContext.Provider>
  );
};

export default FaceTecInstanceInit;
